var map = {
	"./bedrock": 5983,
	"./bedrock.test": 787,
	"./bedrock.test.ts": 787,
	"./bedrock.ts": 5983,
	"./confirmationEmail.test": 7684,
	"./confirmationEmail.test.ts": 7684,
	"./core": 7832,
	"./core.ts": 7832,
	"./cpf": 508,
	"./cpf.test": 8832,
	"./cpf.test.ts": 8832,
	"./cpf.ts": 508,
	"./csc": 6430,
	"./csc.appointments.test": 5002,
	"./csc.appointments.test.ts": 5002,
	"./csc.ts": 6430,
	"./dcat": 7568,
	"./dcat.ts": 7568,
	"./disposal": 9208,
	"./disposal.ts": 9208,
	"./gdad": 7773,
	"./gdad.ts": 7773,
	"./gfie": 1812,
	"./gfie.test": 2292,
	"./gfie.test.ts": 2292,
	"./gfie.ts": 1812,
	"./invite": 6072,
	"./invite.ts": 6072,
	"./psfa": 8781,
	"./psfa.autofill-math.test": 8738,
	"./psfa.autofill-math.test.ts": 8738,
	"./psfa.list-bulk-upload.test": 3725,
	"./psfa.list-bulk-upload.test.ts": 3725,
	"./psfa.order.test": 6899,
	"./psfa.order.test.ts": 6899,
	"./psfa.ts": 8781,
	"./reward": 9753,
	"./reward.encoding.test": 7223,
	"./reward.encoding.test.ts": 7223,
	"./reward.ts": 9753,
	"./rpalogin": 3433,
	"./rpalogin.ts": 3433,
	"./scs": 3480,
	"./scs.minimum-standards.test": 295,
	"./scs.minimum-standards.test.ts": 295,
	"./scs.share-objective.test": 1025,
	"./scs.share-objective.test.ts": 1025,
	"./scs.ts": 3480,
	"./secondments": 5075,
	"./secondments.test": 2350,
	"./secondments.test.ts": 2350,
	"./secondments.ts": 5075,
	"./tableau": 4158,
	"./tableau.test": 2859,
	"./tableau.test.ts": 2859,
	"./tableau.ts": 4158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5887;